/** Common DTOs unique keys */
export enum CommonDtoKeysEnum {
  /** Application short description response body */
  APPLICATION_DESCRIPTION_DTO = 'common/application-description.dto',
  /** API action descriptor */
  API_ACTION_DTO = 'common/api-action.dto',
  /** API error response body */
  API_ERROR_DTO = 'common/api-error.dto',
  /** Auto-disableable object common request and response body */
  AUTO_DISABLEABLE_DTO = 'common/auto-disableable.dto',
  /** Common parsed URL parameters with `:id` numeric parameter */
  DEFAULT_ID_PARAM_DTO = 'common/default-id-param.dto',
  /** Common parsed URL parameters with `:id` string parameter */
  DEFAULT_ID_STRING_PARAM_DTO = 'common/default-id-string-param.dto',
  /** Common parsed URL parameters with `:id` UUID string parameter */
  DEFAULT_UUID_PARAM_DTO = 'common/default-uuid-param.dto',
  /** Common parsed URL parameters with or without `:id` numeric parameter */
  OPTIONAL_ID_PARAM_DTO = 'common/optional-id-param.dto',
  /** Pagination query parameters */
  PAGINATION_QUERY_DTO = 'common/pagination-query.dto',
  /** Standard items list with pagionation API response body (required) */
  PAGINATION_REQUIRED_FIND_DTO = 'common/pagination-required-find.dto',
  /** Paginated entity card history query (`limit`, `offset`, `onlyParticipants`) */
  ENTITY_CARD_HISTORY_QUERY_DTO = 'common/entity-card-history-query.dto',
  /** Standard report analytics */
  REPORT_ANALYTICS_DTO = 'common/report-analytics.dto',
  /** Standard report descriptor */
  REPORT_DESCRIPTOR_DTO = 'common/report-descriptor.dto',
  /** Response body with registry column descriptors only */
  REGISTRY_COLUMNS_RESPONSE_DTO = 'common/registry-columns-response.dto',
  /** Standard report filter descriptor */
  REPORT_FILTER_DESCRIPTOR_DTO = 'common/report-filter-descriptor.dto',
  /** Standard report plot data set ("line") */
  REPORT_PLOT_DATA_SET_DTO = 'common/report-plot-data-set.dto',
  /** Standard report plot type */
  REPORT_PLOT_TYPE_OPTION_DTO = 'common/report-plot-type-option.dto',
  /** Standard report plot */
  REPORT_PLOT_DTO = 'common/report-plot.dto',
  /** Standard report item column descriptor */
  REPORT_ROW_COLUMN_DESCRIPTOR_DTO = 'common/report-row-column-descriptor.dto',
  /** Flat subtotal row tree metadata (hierarchy UI, universal subtotal v2) */
  REPORT_SUBTOTAL_TREE_ROW_DTO = 'common/report-subtotal-tree-row.dto',
  /** Column picker section in registry UI */
  PICKER_GROUP_DTO = 'common/picker-group.dto',
  /** Standard report subroutes */
  REPORT_SUBROUTES_DTO = 'common/report-subroutes.dto',
  /** Common change history log entry base data */
  HISTORY_BASE_DTO = 'common/history-base.dto',
  /** Common change history log entry response body */
  HISTORY_FIND_DTO = 'common/history-find.dto',
  /** Common change history log entries page response body */
  HISTORY_PAGE_DTO = 'common/history-page.dto',
  /** Common change history log target response body */
  HISTORY_TARGET_FIND_DTO = 'common/history-target-find.dto',
  /** Common dates range query */
  DATE_RANGE_QUERY_DTO = 'common/date-range-query.dto',
  /** Common dates range query (required) */
  DATE_RANGE_REQUIRED_QUERY_DTO = 'common/date-range-required-query.dto',
  /** Data range with pagination params */
  DATE_RANGE_WITH_PAGINATION_QUERY_DTO = 'common/date-range-with-pagination-query.dto',
  /** Serialized 1C ERP error. Using by some APIs working with 1C ERP. */
  CONNECTION_1C_ERROR_DTO = 'common/connection-1c-error.dto',
  /** Container object for standard `withDeleted` query parameter */
  WITH_DELETED_QUERY_DTO = 'common/with-deleted-query.dto',
  /** Container object for standard `listStyle` query parameter */
  LIST_STYLE_QUERY_DTO = 'common/list-style-query.dto',
  /** Common search query parameters */
  SEARCH_QUERY_DTO = 'common/search-query.dto',
  /** Common find query parameters */
  FIND_QUERY_DTO = 'common/find-query.dto',
  /** Same as `FindQueryDto` but without required pagination parameters */
  FIND_QUERY_WITHOUT_PAGINATION_DTO = 'common/find-query-without-pagination.dto',
  /** Common parsed URL parameters with `:number` numeric parameter */
  FRM_NUMBER_PARAM_DTO = 'common/frm-number-param.dto',
  /** Common form with email to validate */
  EMAIL_QUERY_DTO = 'common/email-query.dto',
  /** Common response body for some APIs and events which return new fact spent time in minutes */
  FACT_MIN_DTO = 'common/fact-min.dto',
  /** Common IDs' filters query parameters */
  IDS_QUERY_DTO = 'common/ids-query.dto',
  /** Telemetry page hit entry creation params */
  TELEMETRY_PAGE_HIT_FORM_DTO = 'common/telemetry-page-hit-form.dto',
  /** Common URL params for universal exporter APIs */
  UNIVERSAL_EXPORTER_PARAMS_DTO = 'common/universal-exporter-params.dto',
  /** Common UUIDs' filters query parameters */
  UUIDS_QUERY_DTO = 'common/uuids-query.dto',
  /** Common favorite object flag response body */
  IS_FAVORITE_FIND_DTO = 'common/is-favorite-find.dto',
  /** Common dropdown APIs filters query parameters */
  DROPDOWN_BASE_QUERY_DTO = 'common/dropdown-base-query.dto',
  /** Common dropdown APIs filters query parameters (version with UUIDs) */
  DROPDOWN_UUID_QUERY_DTO = 'common/dropdown-uuid-query.dto',
  /** Planning unit settings response body */
  PLANNING_UNIT_FIND_DTO = 'common/planning-unit-find.dto',
  /** Planning unit settings create/update request body */
  PLANNING_UNIT_FORM_DTO = 'common/planning-unit-form.dto',
  /** Deadline settings response body */
  DEADLINE_FIND_DTO = 'common/deadline-find.dto',
  /** Deadline settings create/update request */
  DEADLINE_FORM_DTO = 'common/deadline-form.dto',
  /** Common JSON "page" structure */
  PAGE_FIND_DTO = 'common/page-find.dto',
  /** Common signature for "status" objects (project status, HD task status etc.) */
  STATUS_LIKE_FIND_DTO = 'common/status-like-find.dto',
  /** Common dropdown descriptor */
  STANDARD_DROPDOWN_DESCRIPTOR_DTO = 'common/standard-dropdown-descriptor.dto',
  /** Filters settings for common dropdown */
  STANDARD_DROPDOWN_FILTERS_DTO = 'common/standard-dropdown-filters.dto',
  /** Page response settings for common dropdown */
  STANDARD_DROPDOWN_PAGE_DTO = 'common/standard-dropdown-page.dto',
  /** Properties settings for common dropdown */
  STANDARD_DROPDOWN_PROPERTIES_DTO = 'common/standard-dropdown-properties.dto',
  /** Pagination query params */
  PAGINATION_WITHOUT_ITEMS_QUERY_DTO = 'common/pagination-without-items-query.dto',
  /** Global basic search item body */
  GLOBAL_BASIC_SEARCH_ITEM_DTO = 'common/global-basic-search-item.dto',
  /** Global basic search result body */
  GLOBAL_BASIC_SEARCH_RESULT_DTO = 'common/global-basic-search-result.dto',
  /** Global basic search query body */
  GLOBAL_BASIC_SEARCH_QUERY_DTO = 'common/global-basic-search-query.dto',
  /** Card widget action in card-descriptor */
  CARD_ACTION_DESCRIPTOR_DTO = 'common/card-action-descriptor.dto',
  /** Entity-state visibility rule for a card widget */
  CARD_WIDGET_VISIBLE_WHEN_DTO = 'common/card-widget-visible-when.dto',
  /** KPI metric in card header */
  CARD_HEADER_METRIC_DESCRIPTOR_DTO = 'common/card-header-metric-descriptor.dto',
  /** Pill in card header */
  CARD_HEADER_PILL_DESCRIPTOR_DTO = 'common/card-header-pill-descriptor.dto',
  /** Card header metadata */
  CARD_HEADER_DESCRIPTOR_DTO = 'common/card-header-descriptor.dto',
  /** Card header badge descriptor */
  CARD_HEADER_BADGE_DESCRIPTOR_DTO = 'common/card-header-badge-descriptor.dto',
  /** Card header action bar */
  CARD_HEADER_TOOLBAR_DESCRIPTOR_DTO = 'common/card-header-toolbar-descriptor.dto',
  /** Depends-on paths for a card requisites field editor */
  CARD_FIELD_DEPENDS_ON_DTO = 'common/card-field-depends-on.dto',
  /** Requisites field in card-descriptor */
  CARD_FIELD_DESCRIPTOR_DTO = 'common/card-field-descriptor.dto',
  /** Tab inside a card widget */
  CARD_WIDGET_TAB_DESCRIPTOR_DTO = 'common/card-widget-tab-descriptor.dto',
  /** Single card widget metadata */
  CARD_WIDGET_DESCRIPTOR_DTO = 'common/card-widget-descriptor.dto',
  /** Entity card layout metadata */
  CARD_DESCRIPTOR_DTO = 'common/card-descriptor.dto',
}
